module.exports = __webpack_public_path__ + "img/pf.510d9a06.svg";